import React from 'react'
import { useTranslation } from 'react-i18next'
import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import { TextInput } from '../../../../../../common/inputs/textInput/TextInput'

const fieldId = 'floor-load'
type FloorLoadFieldProps = {
  translationLabel?: string
}

const FloorLoadField: React.FC<FieldProps<OtherFacilitiesScreenValidationResult> & FloorLoadFieldProps> = ({
  insertionData,
  validationMessages,
  screenName,
  onChange,
  wrapperClassName = 'grid-item',
  translationLabel = 'floorLoad',
}) => {
  const { t } = useTranslation()
  return (
    <div className={wrapperClassName}>
      <TextInput
        id={fieldId}
        propertyName='floorLoad'
        placeholder=''
        label={<span>{t(`wizard.screen.otherFacilities.${translationLabel}`, 'Pollution of the ground')}</span>}
        value={insertionData.floorLoad}
        maxLength={9}
        type='text'
        affixRight='icon'
        iconRight={<span className={'font-body-large-regular'}>kg/m²</span>}
        errors={validationMessages?.floorLoad ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}
export default FloorLoadField
